import { render } from "./design_1_block.vue?vue&type=template&id=19d07630&scoped=true"
import script from "./design_1_block.vue?vue&type=script&lang=js"
export * from "./design_1_block.vue?vue&type=script&lang=js"

import "./design_1_block.vue?vue&type=style&index=0&id=19d07630&scoped=true&lang=css"

import exportComponent from "C:\\Прогерство\\vue\\new_site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19d07630"]])

export default __exports__